export default {
  small: '@media (max-width: 700px)',
  medium: '@media (max-width: 900px)'
};
